import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
@Component({
  selector: 'app-distribuidor-frm',
  templateUrl: './distribuidor-frm.component.html',
  styleUrls: ['./distribuidor-frm.component.scss']
})
export class DistribuidorFrmComponent implements OnInit {
  form!: FormGroup;
  submitted = false;


  constructor(private fb: FormBuilder, private auth: AuthService) { }

  ngOnInit(): void {
    this.form = this.createFormulario();
  }

  // getters para facilitar validación en template
  get f() { return this.form.controls; }

  getControl(name: string): AbstractControl {
    return this.form.get(name)!;
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      //  console.log('Formulario invalido');
      return;
    }
    // aquí iría la llamada a tu servicio para guardar...
    console.log('Payload:', this.form.getRawValue());

  }

  createFormulario(): FormGroup {
    return this.fb.group({
      id: [{ value: null, disabled: true }],
      rfc: ['', [Validators.required, Validators.maxLength(16), Validators.pattern(/^([A-ZÑ&]{3,4})(\d{2})(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])[A-Z\d]{3}$/i)]],
      razon_social: ['', [Validators.required, Validators.maxLength(100)]],
      calle: ['', [Validators.required, Validators.maxLength(150)]],
      numero_exterior: ['', [Validators.required, Validators.maxLength(15)]],
      numero_interior: ['', [Validators.maxLength(15)]],
      colonia: ['', [Validators.required, Validators.maxLength(150)]],
      codigo_postal: ['', [Validators.required, Validators.pattern(/^\d{5}$/)]],
      municipio: ['', [Validators.required, Validators.maxLength(150)]],
      estado: ['', [Validators.required, Validators.maxLength(150)]],
      nombre_contacto: ['', [Validators.required, Validators.maxLength(200)]],
      telefono: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
      telefono_contacto: ['', Validators.pattern(/^\d{10}$/)],
      correo_contacto: ['', [Validators.email, Validators.maxLength(255)]],
      fk_usuario: [this.auth.Session?.id]
    });

  }
}
